/* ScreenTitle.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives';
import { breakpointValues, EyebrowSmall, H4, H5, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _2 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _ = "._1yt4ze3t{padding:var(--ds-space-0,0)}";
const headingStyles = null;
export const ScreenTitle = _ref => {
  let {
    title,
    stepInfo
  } = _ref;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  return /*#__PURE__*/_jsx(Box, {
    paddingBlockEnd: isMobile ? 'space.300' : 'space.400',
    children: isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(EyebrowSmall, {
        children: stepInfo
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2]
        }), /*#__PURE__*/_jsx(H5, {
          className: ax(["_1yt4ze3t _18s8ze3t"]),
          children: title
        })]
      })]
    }) : /*#__PURE__*/_jsx(H4, {
      as: "h1",
      children: title
    })
  });
};